import React, { Component, ReactNode } from 'react';
import './Measurement.scss';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import Meter from '../../features/meter/Meter';
import { ToolsQueryState } from './Tools';
import { ERouterPath } from '../../features/router/ERouterPath';
import { Measurement } from '../../models/Measurement';
import { Api } from '../../api';
import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';
import { MeasurementSplitLayout } from './MeasurementSplitLayout';

interface MeasurementComponentState {
  id?: number;
  measurement?: Measurement;
  error?: string;
  submitError?: string;
}

class MeasurementComponent extends Component<RouteComponentProps<any>, MeasurementComponentState> {
  constructor(props: RouteComponentProps<any>) {
    super(props);
    this.state = {
      id: this.getQueryId(this.props.location.search)
    };
  }

  getQueryId(query: string): number|undefined {
    for (const substring of query.split('id=')) {
      const id = +substring;
      if (!isNaN(id)) {
        return id;
      }
    }
    return undefined;
  }

  componentDidMount(): void {
    this.loadMeasurement();
  }

  loadMeasurement(): void {
    if (this.state.id) {
      Api.measurement(this.state.id)
        .then(response => this.setState({ measurement: new Measurement(response) }))
        .catch(() => this.setState({ error: 'Laden van meting mislukt.' }));
    } else {
      this.setState({ error: 'Er is geen meting opgegeven om weer te geven' });
    }
  }

  handleSubmit = (value: number): void => {
    if (this.state.id) {
      Api.measurementAnswer(this.state.id, value)
        .then(() => {
          this.props.history.push(`${ERouterPath.tools}?${ToolsQueryState.MEASUREMENT_SUBMITTED}`);
        })
        .catch(() => this.setState({ submitError: 'Versturen van antwoord mislukt, probeer het later opnieuw' }));
    } else {
      this.setState({ submitError: 'Versturen van de meting mislukt' });
    }
  };

  render(): ReactNode {
    const { measurement, error } = this.state;

    return (
      <MeasurementSplitLayout backButtonOverwrite={ERouterPath.measurementUnanswered} onMeasurementPage={true}>
        <div className="measurement">
          { (!measurement && !error) && <Spinner animation="border" variant="primary" /> }
          { error && <Alert variant="danger">{error}</Alert> }
          {
            measurement &&
              <Meter
                className="measurement__meter"
                type={measurement.type}
                question={measurement.question}
                start={measurement.start}
                end={measurement.end}
                onSubmit={this.handleSubmit}
              />
          }
        </div>
      </MeasurementSplitLayout>
    );
  }
}

export default withRouter(MeasurementComponent);
